import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { KeepComponent } from './keep.component';
import { KeepWarrantyComponent } from './components/keep-warranty/keep-warranty.component';
import { KeepRepairComponent } from './components/keep-repair/keep-repair.component';
import { KeepControlComponent } from './components/keep-control/keep-control.component';
import { KeepRoutineComponent } from './components/keep-routine/keep-routine.component';
import { KeepAppointmentComponent } from './components/keep-appointment/keep-appointment.component';
import { HomeComponent } from '../home/home.component';
import { KeepSearchComponent } from './components/keep-search/keep-search.component';
import { Appointment } from '../common/models/appointment.model';

const routes: Routes = [
  {
    path: '', component: KeepComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'search', component: KeepSearchComponent  },
      { path: 'warranty', component: KeepWarrantyComponent },
      { path: 'repair', component: KeepRepairComponent  },
      { path: 'routine', component: KeepRoutineComponent },
      { path: 'control', component: KeepControlComponent },
      { path: 'appointment', component: KeepAppointmentComponent, data: {appointment: Appointment} },
      //{ path: 'about', component: AboutComponent },
      //{ path: 'services', component: ServicesComponent },
      //{ path: 'contact', component: ContactComponent },
      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class KeepRoutingModule { }
